import { render, staticRenderFns } from "./BranchData.vue?vue&type=template&id=1201f7b4&"
import script from "./BranchData.vue?vue&type=script&lang=js&"
export * from "./BranchData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1201f7b4')) {
      api.createRecord('1201f7b4', component.options)
    } else {
      api.reload('1201f7b4', component.options)
    }
    module.hot.accept("./BranchData.vue?vue&type=template&id=1201f7b4&", function () {
      api.rerender('1201f7b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BranchData.vue"
export default component.exports